module.exports = function(cb) {
  if (typeof requestAnimationFrame !== "undefined") {
    return window.requestAnimationFrame(cb);
  }

  return window.setTimeout(cb, 10);
};